var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.573,
    height: 19.658,
    viewBox: "0 0 24.573 19.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-car-alt",
    "data-name": "Icon awesome-car-alt",
    d: "M22.456,7.593l-.575-1.439L20.861,3.6A5.706,5.706,0,0,0,15.537,0h-6.5A5.706,5.706,0,0,0,3.712,3.6L2.692,6.155,2.116,7.593A3.269,3.269,0,0,0,0,10.648v2.457a3.25,3.25,0,0,0,.819,2.147V18.02a1.638,1.638,0,0,0,1.638,1.638H4.1A1.638,1.638,0,0,0,5.734,18.02V16.382H18.839V18.02a1.638,1.638,0,0,0,1.638,1.638h1.638a1.638,1.638,0,0,0,1.638-1.638V15.252a3.248,3.248,0,0,0,.819-2.147V10.648A3.269,3.269,0,0,0,22.456,7.593ZM6.754,4.821A2.458,2.458,0,0,1,9.036,3.276h6.5a2.458,2.458,0,0,1,2.282,1.545l1.02,2.551H5.734l1.02-2.551ZM4.1,13.1a1.545,1.545,0,0,1-1.638-1.633A1.545,1.545,0,0,1,4.1,9.829a3.152,3.152,0,0,1,2.457,2.45C6.553,13.259,5.078,13.1,4.1,13.1Zm16.382,0c-.983,0-2.457.163-2.457-.817a3.152,3.152,0,0,1,2.457-2.45,1.545,1.545,0,0,1,1.638,1.633A1.545,1.545,0,0,1,20.477,13.1Z",
    fill: "#7477d4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/Car.96be0763b46380ffa497032b5d8c6775.svg";
export { ForwardRef as ReactComponent };